module.exports = __webpack_public_path__ + "img/4.3dbc9089.png";